import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import MobileAdhesionGak from './gak/MobileAdhesion';
import MobileAdhesionFs from './freestar/Adhesion';
const MobileAdhesion = ({ safety ='off'  })=>{
    const isFreestar = useFlag('ads_freestar');
    if (isFreestar) {
        return /*#__PURE__*/ React.createElement(MobileAdhesionFs, {
            safety: safety
        });
    }
    return /*#__PURE__*/ React.createElement(MobileAdhesionGak, {
        safety: safety
    });
};
MobileAdhesion.displayName = 'MobileAdhesion';
export default MobileAdhesion;
